module.exports = __webpack_public_path__ + "static/waves_violet-37d9022b34fe32b9a566104ee1b0b8e9.jpg";